import {
  GET_USER,
  GET_USERS,
  UPLOAD_PICTURE,
  DELETE_USER,
} from "../actions/user.action";

const initialState = {};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER:
      return action.payload;
    case UPLOAD_PICTURE:
      return {
        ...state,
        picture: action.payload,
      };
    case GET_USERS:
      const usersById = {};
      action.payload.forEach((user) => {
        usersById[user._id] = user;
      });
      return {
        ...state,
        users: usersById,
      };
    case DELETE_USER:
      if (state.users) {
        const newUsers = { ...state.users };
        delete newUsers[action.payload];
        return {
          ...state,
          users: newUsers,
        };
      }
      return state;
    default:
      return state;
  }
}
